import { WorldPage } from '_/features/world/ui/pages/world-page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/world/')({
	staticData: { title: 'world_title' },
	component: WorldPage,
})
